import { useEffect, useState } from 'react'

export default function useIsPageVisible(): boolean {
  const [isVisible, setIsVisible] = useState(true)

  const onVisibilityChange = () => {
    setIsVisible(document.visibilityState === 'visible')
  }

  useEffect(() => {
    onVisibilityChange()

    document.addEventListener('visibilitychange', onVisibilityChange)

    return () => {
      document.removeEventListener('visibilitychange', onVisibilityChange)
    }
  }, [])

  return isVisible
}
